import { combineEpics } from "redux-observable";

import getLogsEpic$ from "./getLogsEpic";
import getLogsCountEpic$ from "./getLogsCountEpic";
import exportLogsCsvEpic$ from "./exportLogsCsvEpic";

export default combineEpics(
  getLogsEpic$,
  getLogsCountEpic$,
  exportLogsCsvEpic$
);



// WEBPACK FOOTER //
// ./src/features/log/epics/index.js